import React from "react";
import Cookies from "js-cookie";

const Scope = ({ children }) => {
  const hasGMBRoleId =
    Cookies.get("ssp_role") === "1081" ||
    Cookies.get("ssp_role") === "1345" ||
    Cookies.get("ssp_role") === "1346" ||
    Cookies.get("ssp_role") === "1080";

  if (!hasGMBRoleId) {
    return <div className="text-center h-full w-full">You do not have the required role to access this module</div>;
  }

  return <>{children}</>;
};

export default Scope;
